import React from "react";

const pagesRoutes = [
  {
    path: "/dashboard",
    component: React.lazy(() => import("./dashboard/dashboard")),
  },
  {
    path: "/dashboard-reseller",
    component: React.lazy(() => import("./dashboard/resellerDashboard")),
  },
  {
    path: "/dashboard-reseller-wise/:id/:name",
    component: React.lazy(() => import("./dashboard/resellerWiseDashboard")),
  },

  //admin order
  {
    path: "/create-order",
    component: React.lazy(() => import("./order/posOrder/posOrder")),
  },
  {
    path: "/update-order/:serialId",
    component: React.lazy(
      () => import("./order/posOrderUpdate/posOrderUpdate"),
    ),
  },
  {
    path: "/abandon-order-list",
    component: React.lazy(
      () => import("./order/abandonOrderList/abandonOrderList.jsx"),
    ),
  },
  {
    path: "/order-list",
    component: React.lazy(() => import("./order/orderList/orderlist")),
  },
  {
    path: "/order-view/:serialId",
    component: React.lazy(() => import("./order/orderView/orderView")),
  },
  {
    path: "/multiple-order-view",
    component: React.lazy(() => import("./order/orderView/multipleOrderView")),
  },
  {
    path: "/bulk-steadfast",
    component: React.lazy(
      () => import("./order/bulkCourier/bulkSteadfast.jsx"),
    ),
  },
  {
    path: "/bulk-pathao",
    component: React.lazy(() => import("./order/bulkCourier/bulkPathao.jsx")),
  },
  {
    path: "/bulk-carry-bee",
    component: React.lazy(() => import("./order/bulkCourier/bulkCarryBee.jsx")),
  },

  // reseller order
  {
    path: "/reseller-order-list",
    component: React.lazy(
      () => import("./order/resellerOrderList/resellerOrderList.jsx"),
    ),
  },
  {
    path: "/reseller-create",
    component: React.lazy(() => import("./Reseller/resellerCreate.jsx")),
  },
  {
    path: "/reseller-update/:id",
    component: React.lazy(() => import("./Reseller/updateReseller.jsx")),
  },
  {
    path: "/reseller-invoice-list",
    component: React.lazy(
      () => import("./Reseller/resellerPayment/resellerInvoiceList.jsx"),
    ),
  },

  // {
  //   path: "/update-affiliate-order/:serialId/:type",
  //   component: React.lazy(() =>
  //     import("./order/posOrderUpdate/posOrderUpdate")
  //   ),
  // },
  // {
  //   path: "/reseller-order-view/:serialId",
  //   component: React.lazy(() => import("./order/reSellerOrderView/orderView")),
  // },
  // {
  //   path: "/reseller-multiple-order-view",
  //   component: React.lazy(() =>
  //     import("./order/reSellerOrderView/multipleOrderView")
  //   ),
  // },
  {
    path: "/order-return-refund",
    component: React.lazy(() => import("./order/returnRefund/returnRefund")),
  },

  // purchase
  {
    path: "/create-purchase",
    component: React.lazy(
      () => import("./purchase/purchaseCreate/createPurchase"),
    ),
  },
  {
    path: "/purchase-list",
    component: React.lazy(() => import("./purchase/purchaseList/purchaseList")),
  },
  {
    path: "/purchase-view/:serialId",
    component: React.lazy(() => import("./purchase/purhaseView/purchaseView")),
  },

  // stock in
  {
    path: "/stock-in-create",
    component: React.lazy(
      () => import("../Pages/stockManage/stockIn/createStockIn.jsx"),
    ),
  },
  {
    path: "/stock-in-list",
    component: React.lazy(
      () => import("./stockManage/stockIn/stockInList/stockInList.jsx"),
    ),
  },
  {
    path: "/stock-in-view/:serialId",
    component: React.lazy(
      () => import("./stockManage/stockIn/stockInView.jsx"),
    ),
  },
  // stock in
  {
    path: "/stock-lost-create",
    component: React.lazy(
      () => import("../Pages/stockManage/stockOut/createStockOut.jsx"),
    ),
  },
  {
    path: "/stock-lost-list",
    component: React.lazy(
      () => import("./stockManage/stockOut/stockOutList/stockOutList.jsx"),
    ),
  },
  {
    path: "/stock-lost-view/:serialId",
    component: React.lazy(
      () => import("./stockManage/stockOut/stockOutView.jsx"),
    ),
  },

  {
    path: "/customer",
    component: React.lazy(() => import("./customer/customerList")),
  },
  {
    path: "/sms-list",
    component: React.lazy(() => import("./sms/smsList")),
  },
  {
    path: "/direct-sms",
    component: React.lazy(() => import("./sms/bulkMsgSend")),
  },
  {
    path: "/create-supplier",
    component: React.lazy(() => import("./supplier/createSupplier")),
  },
  {
    path: "/update-supplier/:supplierId",
    component: React.lazy(() => import("./supplier/updateSupplier")),
  },
  {
    path: "/supplier-list",
    component: React.lazy(() => import("./supplier/supplierList")),
  },
  {
    path: "/expense-head",
    component: React.lazy(() => import("./expenseHead/expenseHead")),
  },
  {
    path: "/create-expense",
    component: React.lazy(() => import("./expense/createExpense")),
  },
  {
    path: "/update-expense/:expenseId",
    component: React.lazy(() => import("./expense/updateExpense")),
  },
  {
    path: "/expense-list",
    component: React.lazy(() => import("./expense/expenseList")),
  },
  {
    path: "/create-product",
    component: React.lazy(
      () => import("./product/createProduct/createProducts"),
    ),
  },
  {
    path: "/bulk-product",
    component: React.lazy(
      () => import("./product/createBulkProduct/createBulkProduct.jsx"),
    ),
  },
  {
    path: "/update-product/:productSlug",
    component: React.lazy(
      () => import("./product/updateProduct/updateProducts"),
    ),
  },
  {
    path: "/product-list",
    component: React.lazy(() => import("./product/productList/productList")),
  },
  // {
  //   path: "/alert-products",
  //   component: React.lazy(() => import("./product/stockAlert/stockAlert")),
  // },
  {
    path: "/create-category",
    component: React.lazy(() => import("./category/createCategory")),
  },
  {
    path: "/update-category/:categoryId",
    component: React.lazy(() => import("./category/updateCategory")),
  },
  {
    path: "/category-list",
    component: React.lazy(() => import("./category/CategoryList")),
  },
  {
    path: "/create-attribute",
    component: React.lazy(() => import("./attributes/createAttribute")),
  },
  {
    path: "/update-attribute/:attributeId",
    component: React.lazy(() => import("./attributes/updateAttribute")),
  },
  {
    path: "/attribute-list",
    component: React.lazy(() => import("./attributes/AttributeList")),
  },
  {
    path: "/create-attribute-value",
    component: React.lazy(() => import("./attributes/createAttributeValue")),
  },
  {
    path: "/update-attribute-value/:attributeValueId",
    component: React.lazy(() => import("./attributes/updateAttributeValue")),
  },
  {
    path: "/attribute-value-list",
    component: React.lazy(() => import("./attributes/AttributeValueList ")),
  },
  {
    path: "/create-brand",
    component: React.lazy(() => import("./brand/createBrand")),
  },
  {
    path: "/update-brand/:brandId",
    component: React.lazy(() => import("./brand/updateBrand")),
  },
  {
    path: "/brand-list",
    component: React.lazy(() => import("./brand/brandList")),
  },
  {
    path: "/sticker",
    component: React.lazy(() => import("./sticker/sticker")),
  },
  {
    path: "/product-rating",
    component: React.lazy(() => import("./ratings/ratingList")),
  },
  {
    path: "/create-promo",
    component: React.lazy(() => import("./promo/createPromo")),
  },
  {
    path: "/update-promo/:promoId",
    component: React.lazy(() => import("./promo/updatePromo.jsx")),
  },
  {
    path: "/promo-list",
    component: React.lazy(() => import("./promo/promoList")),
  },
  {
    path: "/create-campaign",
    component: React.lazy(() => import("./campaign/createCampaign")),
  },
  {
    path: "/update-campaign/:campaignId",
    component: React.lazy(() => import("./campaign/updateCampaign")),
  },
  {
    path: "/view-campaign/:campaignId",
    component: React.lazy(() => import("./campaign/Details/viewCampaign")),
  },
  {
    path: "/campaign-list",
    component: React.lazy(() => import("./campaign/campaignList")),
  },
  // {
  //   path: "/section/:sectionSlug",
  //   component: React.lazy(() =>
  //     import("./section/sectionProducts/sectionProducts")
  //   ),
  // },
  // {
  //   path: "/section",
  //   component: React.lazy(() => import("./section/sectionCrud/sectionDetails")),
  // },
  {
    path: "/flash-deal",
    component: React.lazy(() => import("./flashdeal/flashdeal")),
  },
  {
    path: "/courier",
    component: React.lazy(() => import("./courier/courier")),
  },
  {
    path: "/courier-service",
    component: React.lazy(() => import("./courierService/courierService.jsx")),
  },
  // {
  //   path: "/divisions",
  //   component: React.lazy(() => import("./locations/divisions")),
  // },
  {
    path: "/districts",
    component: React.lazy(() => import("./locations/district")),
  },
  {
    path: "/upazila",
    component: React.lazy(() => import("./locations/upazila")),
  },
  {
    path: "/create-employee",
    component: React.lazy(() => import("./employee/createEmployee")),
  },
  {
    path: "/employee-list",
    component: React.lazy(() => import("./employee/employeeList.jsx")),
  },
  {
    path: "/employee-role/:employeeId",
    component: React.lazy(() => import("./employee/rolePermission")),
  },

  //= own website
  {
    path: "/own-general",
    component: React.lazy(() => import("./OwnWebsite/profile")),
  },
  {
    path: "/home-view",
    component: React.lazy(() => import("./OwnWebsite/homeView/homeView.jsx")),
  },
  {
    path: "/page-update",
    component: React.lazy(() => import("./OwnWebsite/singlePage/pageUpdate")),
  },
  {
    path: "/page-view",
    component: React.lazy(() => import("./OwnWebsite/singlePage/pagesView")),
  },
  {
    path: "/pop-up-img",
    component: React.lazy(() => import("./OwnWebsite/media/popupImg")),
  },
  {
    path: "/slider-img",
    component: React.lazy(() => import("./OwnWebsite/media/sliders")),
  },
  {
    path: "/brand-img",
    component: React.lazy(() => import("./OwnWebsite/media/brandImg")),
  },
  {
    path: "/fb-pixel",
    component: React.lazy(() => import("./OwnWebsite/media/fbPixel")),
  },
  {
    path: "/google-scripts",
    component: React.lazy(() => import("./OwnWebsite/media/google")),
  },
  {
    path: "/tiktok-pixel",
    component: React.lazy(() => import("./OwnWebsite/media/tiktokPixel")),
  },
  {
    path: "/other-scripts",
    component: React.lazy(() => import("./OwnWebsite/media/thirdPartyScripts")),
  },
  {
    path: "/banner-img",
    component: React.lazy(() => import("./OwnWebsite/media/bannerImg")),
  },
  {
    path: "/banner-text",
    component: React.lazy(() => import("./OwnWebsite/media/bannerText")),
  },

  //= reseller website
  {
    path: "/reseller-general",
    component: React.lazy(() => import("./resellerWebsite/profile")),
  },
  {
    path: "/reseller-page-update",
    component: React.lazy(
      () => import("./resellerWebsite/singlePage/pageUpdate"),
    ),
  },
  {
    path: "/reseller-page-view",
    component: React.lazy(
      () => import("./resellerWebsite/singlePage/pagesView"),
    ),
  },

  {
    path: "/advance-payment-list",
    component: React.lazy(
      () => import("./Reseller/resellerPayment/advancePaymentList"),
    ),
  },

  //  advance-payment-list
  {
    path: "/reseller-slider-img",
    component: React.lazy(() => import("./resellerWebsite/media/sliders")),
  },

  // settings
  {
    path: "/password",
    component: React.lazy(() => import("./settings/password.jsx")),
  },
  {
    path: "/delivery-charge",
    component: React.lazy(() => import("./settings/deliveryCharge")),
  },

  {
    path: "/city",
    component: React.lazy(() => import("./settings/Location/City.jsx")),
  },
  {
    path: "/location",
    component: React.lazy(() => import("./settings/Location/Location.jsx")),
  },

  {
    path: "/payment-receive",
    component: React.lazy(() => import("./settings/paymentReceive.jsx")),
  },

  {
    path: "/product-report",
    component: React.lazy(() => import("./report/productReport")),
  },

  {
    path: "/account-report",
    component: React.lazy(() => import("./report/accountReport")),
  },
  {
    path: "/return-order-report",
    component: React.lazy(() => import("./report/returnOrderProductReport.js")),
  },
  {
    path: "/lost-order-product-report",
    component: React.lazy(() => import("./report/lostOrderProductReport.js")),
  },
  {
    path: "/invoice-confirm-report",
    component: React.lazy(() => import("./report/invoiceConfirmReport.js")),
  },
  {
    path: "/order-report",
    component: React.lazy(() => import("./report/orderReport.js")),
  },

  // user- Reseller
  {
    path: "/create-reseller",
    component: React.lazy(() => import("./Reseller/resellerCreate.jsx")),
  },
  {
    path: "/reseller-list",
    component: React.lazy(() => import("./Reseller/resellerList.jsx")),
  },
  {
    path: "/product-reports",
    component: React.lazy(() => import("./report/productTableReport.js")),
  },
  {
    path: "/reseller-reports",
    component: React.lazy(() => import("./report/resellerTableReport.js")),
  },
  {
    path: "/emp-reports",
    component: React.lazy(() => import("./report/topEmpReport.js")),
  },
  {
    path: "/stock-in-reports",
    component: React.lazy(() => import("./report/stockInReport.js")),
  },
  {
    path: "/stock-out-reports",
    component: React.lazy(() => import("./report/stockOutReport.js")),
  },
  {
    path: "/purchase-reports",
    component: React.lazy(() => import("./report/purchaseReport.js")),
  },
  {
    path: "/lost-order",
    component: React.lazy(() => import("./order/lossOrder.jsx")),
  },

  {
    path: "/vendor-registration",
    component: React.lazy(
      () => import("./vendor/vendorRegistration/registerVendor.jsx"),
    ),
  },
  {
    path: "/vendor-list",
    component: React.lazy(
      () => import("./vendor/vendorRegistration/vendorList.jsx"),
    ),
  },
  {
    path: "/update-vendor/:vendorId",
    component: React.lazy(
      () => import("./vendor/vendorRegistration/updateVendor.jsx"),
    ),
  },
  {
    path: "/vendor-product-create/:uploadId/:vendorId",
    component: React.lazy(
      () => import("./vendor/product/createProduct/createProducts.jsx"),
    ),
  },
  {
    path: "/vendor-uploads",
    component: React.lazy(() => import("./vendor/product/vendorUpload.jsx")),
  },
  {
    path: "/vendor-product-list",
    component: React.lazy(
      () => import("./vendor/product/productList/productList.jsx"),
    ),
  },
  {
    path: "/orderWise-Vendor-list",
    component: React.lazy(
      () => import("./vendor/vendorOrder/orderWiseVendorList.jsx"),
    ),
  },
  {
    path: "/vendor-order-wise-product-list/:id",
    component: React.lazy(
      () => import("./vendor/vendorOrder/vendorOrderProductList.jsx"),
    ),
  },
  {
    path: "/print-payment-invoice/:id",
    component: React.lazy(
      () => import("./Reseller/resellerPayment/resellerInvoicePrint.jsx"),
    ),
  },
  {
    path: "/add-courier",
    component: React.lazy(() => import("./addPathao/addPathaoCourier")),
  },
  {
    path: "/vendor-pending-collection-list",
    component: React.lazy(
      () => import("./vendor/collections/pendingCollectionList.jsx"),
    ),
  },
  {
    path: "/vendor-accepted-collection-list",
    component: React.lazy(
      () => import("./vendor/collections/acceptedCollectionList.jsx"),
    ),
  },
  {
    path: "/vendor-cancelled-collection-list",
    component: React.lazy(
      () => import("./vendor/collections/cancelledCollectionList.jsx"),
    ),
  },
  {
    path: "/vendor-pending-payment",
    component: React.lazy(
      () => import("./vendor/vendorPayment/pendingPayment.jsx"),
    ),
  },
  {
    path: "/vendor-accepted-payment",
    component: React.lazy(
      () => import("./vendor/vendorPayment/acceptedPaymentList.jsx"),
    ),
  },
  {
    path: "/vendor-rejected-payment",
    component: React.lazy(
      () => import("./vendor/vendorPayment/rejectedpaymentList.jsx"),
    ),
  },

  {
    path: "/scan-to-return",
    component: React.lazy(() => import("./order/orderSearch/scanToReturn.jsx")),
  },
  {
    path: "/scan-to-action",
    component: React.lazy(
      () => import("./order/orderSearch/scanForBulkAction.jsx"),
    ),
  },
  // {
  //   path: "/add-manual-payment",
  //   component: React.lazy(() => import("./manualPayment/manualPayment.jsx")),
  // },
  // {
  //   path: "/manual-payment-list",
  //   component: React.lazy(() => import("./manualPayment/paymentList.jsx")),
  // },
  // {
  //   path: "/update-manual-pay/:payId",
  //   component: React.lazy(() =>
  //     import("./manualPayment/updateManualPayment.jsx")
  //   ),
  // },
  // {
  //   path: "/create-combo",
  //   component: React.lazy(() => import("./comboProduct/addComboProduct")),
  // },
  // {
  //   path: "/combo-list",
  //   component: React.lazy(() => import("./comboProduct/comboList")),
  // },
  // {
  //   path: "/update-comboProduct/:comId",
  //   component: React.lazy(() => import("./comboProduct/updateCombo")),
  // },
  // {
  //   path: "/create-showroom",
  //   component: React.lazy(() => import("./showroom/createShowroom")),
  // },
  // {
  //   path: "/showroom-list",
  //   component: React.lazy(() => import("./showroom/showroomList")),
  // },
  // {
  //   path: "/update-showroom/:showId",
  //   component: React.lazy(() => import("./showroom/updateShowroom")),
  // },

  {
    path: "/material/icons",
    component: React.lazy(() => import("./../icons/AppIcon.jsx")),
  },

  // ADDITION
  {
    path: "/order-request",
    component: React.lazy(
      () => import("./../Pages/order/orderRequest/orderRequest.jsx"),
    ),
  },
];

export default pagesRoutes;
